module.exports = __webpack_public_path__ + "static/media/Stone-Island-Green-Sage-Wool-Blend-Jumper-Lyst.d20dd981.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/products/mens/Stone-Island-Green-Sage-Wool-Blend-Jumper-Lyst.png
// module id = 258
// module chunks = 0